import PicklistMetadata from "../PicklistMetadata";

// Non-static picklist over the Lookup EC, so a Reference data type can name the reference list it
// resolves through by picking it rather than by pasting a USID.
//
// Display = the list's Name, which is what a person calls it and what a FromLookup rule names it by.
// Value = USID, because the resolver stores the key: a lookup renamed after a type was defined must
// not orphan that type, and phase 3 makes lookups revisioned, at which point "the list called X"
// stops being one thing.
//
// NOT PERSONA-SCOPED, unlike CatalogItem beside it, and that is deliberate rather than an omission.
// Reference data is realm-wide by design -- the Lookup EC declares no visibility modes, exactly as
// DataType does -- because a shared vocabulary that some people cannot see is not a shared
// vocabulary. Adding visibilityType here would hide lists from the very authors meant to bind to
// them, and would be the first thing in the product to suggest reference data is ownable.
class LookupPicklistMetadata extends PicklistMetadata {
    constructor() {
        super();

        this.name = "Lookup";
        this.static = false;
        this.enterpriseComponent = "Lookup";
        this.useRealm = true;
        this.searchSpecification = null;
        this.sortSpecification = {"Name": "ASC"};
        this.typeField = "Name";
        this.typeValue = "USID";
        this.allowNoSelection = false;
        this.visibilityType = null;
    }
}

export default LookupPicklistMetadata;
